import { createActionHandler, createReducer, OperationStatus } from '@pressreader/appstore';
import { popupOpened } from '@pressreader/popups-core';

import { BlockedUserProfile } from '../../types/blocked.user.profile';
import { loadBlockedUsersBegan, loadBlockedUsersDone, loadBlockedUsersFailed, userUnblocked } from '../actions/blocked.users';
import { isBlockedUsersPopupOpenedAction } from '../utils';

interface State {
    status: OperationStatus;
    users: BlockedUserProfile[];
}

const initialState: State = {
    status: OperationStatus.None,
    users: [],
};

const reducer = createReducer(
    initialState,
    createActionHandler(popupOpened, (state, action): State => (isBlockedUsersPopupOpenedAction(action) ? initialState : state)),
    createActionHandler(
        loadBlockedUsersBegan,
        (state): State => ({
            ...state,
            status: OperationStatus.Pending,
        }),
    ),
    createActionHandler(
        loadBlockedUsersDone,
        (state, { payload }): State => ({
            status: OperationStatus.Done,
            users: payload.users,
        }),
    ),
    createActionHandler(
        loadBlockedUsersFailed,
        (state): State => ({
            ...state,
            status: OperationStatus.Failed,
        }),
    ),
    createActionHandler(
        userUnblocked,
        (state, { payload }): State => ({
            ...state,
            users: state.users.filter(user => user.profileName !== payload.profileName),
        }),
    ),
);

export { reducer, State };
